




















import { ContextLabel } from "@/common/models";
import { SharedState } from "@/common/state";
import { clone, groupBy } from "@/fp";
import { onMounted, Ref, ref } from "@vue/composition-api";
import Vue from "vue";
import AppCheckbox from "../AppCheckbox.vue";
import SimpleAppDetails from "../SimpleAppDetails.vue";
export default Vue.extend({
  components: { SimpleAppDetails, AppCheckbox },
  setup() {
    const ctx_groups: Ref<Array<{ name: string; labels: ContextLabel[] }>> =
      ref([]);

    onMounted(() => {
      const cloned_labels = clone(SharedState.context_labels.value, true);
      const labels = groupBy<ContextLabel>("labelCategory", cloned_labels);
      ctx_groups.value = Array.from(labels.entries()).map(
        ([group_name, ctx_labels]) => ({ name: group_name, labels: ctx_labels })
      );
    });
    return {
      ctx_groups,
    };
  },
});
